(ns frontend.view.nev.kyc.process-status-views.print-view
  (:require
   [basic-components.inputs.footprint :refer [viewer]]
   [frontend.view.nev.kyc.process.kyc-editor :as kyc-editor]
   [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
   [frontend.utils :as fu]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [frontend.view.nev.kyc.process.screening-profile-table :as screening-table]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn print-hiccup
  [{:keys [state-atom entity]}]
  (let [template-schema (template-registry/templates (:kyc-process/template entity))
        answers-atom (r/cursor state-atom [:kyc-process/answers])]
    (edit-view/fill-updates-form-CRM state-atom answers-atom entity)
    (fn [{:keys [lang state-atom entity save! mandatory? read-only? footer-renderer]}]
      (let [lang-kw (if (= :FIN lang) :fi :en)]
        [:div.d-flex.flex-column.flex-1-hidden
         [:div.d-flex.flex-column.flex-1-hidden.scroll-y-container
          [:div.d-flex.flex-column.flex-1-hidden.scroll-y
           [:div.kyc-print
            [:div
             [:div.container.pt-4
              [:div.card--kyc
               [:div.card-body
                [:img.horizontal-page__body-top-logo
                 {:src (fu/sanitize-img-url (:kyc-template/png-logo template-schema))}]
                [:h1
                 (-> template-schema
                     :kyc-template/kyc-form-title
                     :translations
                     (get lang-kw))]]]]
             [:div.container.pt-4
              [:div.card--kyc
               [:div.card-body
                [viewer
                 {:editor/type :editor.type/wysiwyg
                  :value       (some-> template-schema
                                       :kyc-template/kyc-form-preface
                                       (get lang-kw))}]]]]
             [kyc-editor/kyc-entity-editor
              {:state-atom      state-atom
               :container-id    "kyc-print-view"
               :process-id      (:db/id entity)
               :save!           save!
               :answers-atom    answers-atom
               :template-schema template-schema
               :read-only?      read-only?
               :skip-info?      true
               :print?          true
               :mandatory?      mandatory?
               :lang-kw         lang-kw}]

             (when (and (session/screening?)
                        (tenant-customizations/capman?)
                        (some #{(:kyc-process/status entity)}
                              [:kyc-process.status/waiting-for-e-sign
                               :kyc-process.status/submitted
                               :kyc-process.status/approved
                               :kyc-process.status/approved-modified]))
               [screening-table/view
                {:kyc-process  entity
                 :answers-atom answers-atom}])]]]
          (when footer-renderer
            [footer-renderer state-atom answers-atom entity])]]))))
